// extracted by mini-css-extract-plugin
export var cancelText = "SavedCardSubmit-module--cancelText--NIWSe";
export var ctaSection = "SavedCardSubmit-module--ctaSection--UVCik";
export var encryptionSubText = "SavedCardSubmit-module--encryptionSubText--NtBdR";
export var encryptionWrapper = "SavedCardSubmit-module--encryptionWrapper--i1D8a";
export var logo = "SavedCardSubmit-module--logo--WRFzB";
export var payBtn = "SavedCardSubmit-module--payBtn--YToux";
export var price = "SavedCardSubmit-module--price--orGSm";
export var subConsentText = "SavedCardSubmit-module--subConsentText--s0eoJ";
export var subText = "SavedCardSubmit-module--subText--c5Gig";
export var submitSection = "SavedCardSubmit-module--submitSection--wU3pX";
export var terms = "SavedCardSubmit-module--terms--ad+Y7";
export var text = "SavedCardSubmit-module--text--h3JJa";
export var topSection = "SavedCardSubmit-module--topSection--SOXom";
export var weeks = "SavedCardSubmit-module--weeks--qwmas";